import GigyaController from '@/utils/Controllers/Gigya/GigyaController';
import {
  bindGigyaToggleContent,
  handleModalWorkflows,
} from '@/utils/Controllers/Gigya/Utils';
import { goLogin } from '@/utils/Common/Redirects';
import EVENTS from '@/utils/Constants/Events';
import CONST from '@/utils/Constants/General';

// import api
import apiGigyaRegisterInfo from '@/api/post/gigyaRegisterInfo';
import pushGtmSiteSignup from '@/utils/Controllers/GTM/Operations/SiteSignUp';

const CONTAINER_ID = 'js-dlg-gigya-register-container';
const START_SCREEN = 'gigya-register-screen';

export default class GigyaRegisterController {
  static screenSetConfig = {
    startScreen: START_SCREEN,
    containerID: CONTAINER_ID,
    onBeforeSubmit: GigyaRegisterController.onBeforeSubmit,
    onBeforeScreenLoad: GigyaRegisterController.onBeforeScreenLoad,
    onSubmit: GigyaRegisterController.onSubmit,
    onAfterSubmit: GigyaRegisterController.onAfterSubmit,
    onAfterScreenLoad: GigyaRegisterController.onAfterScreenLoad,
  };

  static init() {
    DLG.EVE.on(EVENTS.GIGYA.REDIRECT.LOGIN, goLogin);
    DLG.EVE.on(
      EVENTS.GIGYA.REDIRECT.REGISTER,
      GigyaRegisterController.refreshRegister,
    );
    GigyaController.listenToLogin();
    GigyaController.loadScreen(GigyaRegisterController.screenSetConfig);
  }

  static onBeforeSubmit(res) {
    if (res.formData['data.emailConfirm']) {
      return res.formData['data.emailConfirm'] === res.formData.email;
    }
    return true;
  }

  static onSubmit(res) {
    const lang = gigya.thisScript.lang.originalLang;
    const countryCode = gigya.thisScript.globalConf.countryCodeMapping[lang];
    const countryPrefix =
      gigya.thisScript.globalConf.phonePrefixMapping[countryCode];
    const currentPhone = res.formModel.data.phones.mobile;
    if (currentPhone) {
      res.formModel.data.phones.mobile = `${countryPrefix}${currentPhone}`;
    }
  }

  static handleRegistration(event, callback) {
    // GET USER INFO
    // get the user UID
    const gigyaUID = event.response.UID;
    // get the locale
    const lang = gigya.thisScript.lang.originalLang;
    // get the country code
    const countryCode = gigya.thisScript.globalConf.countryCodeMapping[lang];
    // get the consent field related to the country code
    const siteConsent = gigya.thisScript.globalConf.consentMapping[countryCode];
    // get the boolean value of the consent checkbox
    const isChecked = document.querySelector(
      '#js-dlg-gigya-register-container .gigya-custom-checkbox .gigya-input-checkbox',
    ).checked;
    // get user email
    const { email } = event.profile;
    // the identifier
    const identifier = CONST.GIGYA.ORIGIN.ECOMMERCE;
    // get the sms consent uf the user entered his mobile number
    const smsConsent = !!event.data?.phones?.mobile;
    // SEND USER INFO TO BE
    apiGigyaRegisterInfo({
      info: {
        gigyaUID,
        lang,
        countryCode,
        siteConsent,
        isChecked,
        identifier,
        smsConsent,
      },
      successCB: () => callback(gigyaUID, email),
    });
  }

  static onAfterSubmit(event) {
    GigyaController.onAfterSubmit();
    const successCB = (gigyaUID, email = '') => {
      pushGtmSiteSignup(gigyaUID, email);
    };
    GigyaRegisterController.handleRegistration(event, successCB);
  }

  static onBeforeScreenLoad(res) {
    let interval;
    let intervalC = 0;
    const intervalM = 30;
    (() => {
      interval = setInterval(() => {
        const form = document.getElementById('gigya-register-form');
        if (intervalC > intervalM) {
          clearInterval(interval);
        } else if (form !== null) {
          clearInterval(interval);
          const inputName = form.querySelectorAll(
            '[name = "profile.firstName"]',
          );
          const inputSurname = form.querySelectorAll(
            '[name = "profile.lastName"]',
          );
          const inputEmail = form.querySelectorAll('[data-gigya-name="email"]');
          inputName[0].setAttribute('maxlength', '40');
          inputSurname[0].setAttribute('maxlength', '40');
          inputEmail[0].setAttribute('type', 'email');
        }
        intervalC += 1;
      }, 1000);
    })();
    return handleModalWorkflows(res);
  }

  static refreshRegister() {
    const popup = document.querySelector('.dln-popup.dln-popup--open');
    if (popup) {
      DLG.EVE.emit(EVENTS.MODAL.CLOSE, { popup });
    }
  }

  static onAfterScreenLoad(event) {
    GigyaController.onAfterScreenLoad(event);
    bindGigyaToggleContent(event.sourceContainerID, '#gigya-register-form');
  }
}
